import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center space-y-6">
        <h1 className="text-8xl font-bold text-primary">404</h1>
        <h2 className="text-2xl font-semibold text-foreground">The requested path could not be found</h2>
        <Button onClick={() => navigate("/business-summary")} variant="default">
          Go to Business Summary
        </Button>
      </div>
    </div>
  );
};

export default NotFound;